import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const careers = ["Future", "Skills", "Career"];

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % careers.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-gradient-to-r from-red-700 via-blue-800 to-red-900 text-white text-center py-20 px-6 rounded-2xl flex flex-col items-center justify-center min-h-[60vh]">
      {/* Title */}
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight">
        Learn cybersecurity, invest in your{" "}
        <span className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-red-400 ml-2 min-w-[120px]">
          <AnimatePresence mode="wait">
            <motion.span
              key={careers[index]}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -30, opacity: 0 }}
              transition={{ duration: 0.6 }}
              className="inline-block"
            >
              {careers[index]}
            </motion.span>
          </AnimatePresence>
        </span>
      </h1>

      {/* Buttons */}
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <button className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition duration-300">
          Start for Free
        </button>
        <button className="border-2 border-white text-white hover:bg-white hover:text-blue-700 font-semibold px-6 py-3 rounded-lg transition duration-300">
          For Business
        </button>
      </div>
    </div>
  );
}
